import React, { FC, useContext, useState } from 'react';

import { Button, Separator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';
import { IRole } from 'types';

import { RolesTableProps } from '../../types';
import RolesTableModal from './components/RolesTableModal';
import s from './RolesTable.module.scss';

const RolesTable: FC<RolesTableProps> = ({ roles }) => {
  const { t } = useContext(LocalizationContext);

  const [selectedRole, setSelectedRole] = useState<Pick<
    IRole,
    'id' | 'alias'
  > | null>(null);

  return (
    <>
      {selectedRole && (
        <RolesTableModal
          role={selectedRole}
          close={() => setSelectedRole(null)}
        />
      )}
      <div className={s.container}>
        <FeatureHOC
          alias="customizable_permissions"
          strategy="replace"
          nameKey="roles.tab.title"
          fullHeight
        >
          <div className={s.item}>{t('worker.role')}</div>
          <Separator />
          {roles
            ?.filter(({ id }) => id !== 3)
            ?.map((role) => (
              <div
                className={cn(s.item, role?.id === 1 && s.disabled)}
                key={role?.id}
              >
                <span>{t(`roles.${role?.alias}`)}</span>
                {role?.id === 1 ? (
                  <span className={s.placeholder}>
                    {t('roles.owner.placeholder')}
                  </span>
                ) : (
                  <Button
                    onlyIcon
                    iconName="EditIcon"
                    variant="ghost"
                    size="s"
                    className={s.button}
                    onClick={() => setSelectedRole(role)}
                  />
                )}
              </div>
            ))}
        </FeatureHOC>
      </div>
    </>
  );
};

export default RolesTable;
